<script setup lang="ts">
import { computed } from 'vue';
import Textarea from 'primevue/textarea';
import { InputGroup, Typography } from '@apparatix/library/core';
import DetailEditorBase from './DetailEditorBase.vue';
import type { AccountNoteErrors } from '@apparatix/schemas/AccountNotes';

type Props = {
  noHeadingLabels?: boolean;
  errors: AccountNoteErrors;
}

const props = defineProps<Props>();

const leftColLabel = computed(() => {
  if (props.noHeadingLabels) return undefined;
  return 'Account Notes';
});

const rightColLabel = computed(() => 'A/R');

const accountNotes = defineModel<string>('accountNotes');
const arNotes = defineModel<string>('arNotes');

</script>
<template>
  <DetailEditorBase :left-col-header="leftColLabel" :right-col-header="rightColLabel">
    <template #left-col>
      <InputGroup>
        <Textarea
          v-model="accountNotes"
          auto-resize
          variant="filled"
          fluid
        />
        <Typography v-if="Boolean(props.errors?.accountNotes)" variant="form-error">
          {{ props.errors.accountNotes }}
        </Typography>
      </InputGroup>
    </template>
    <template #right-col>
      <InputGroup>
        <Textarea
          v-model="arNotes"
          auto-resize
          variant="filled"
          fluid
        />
        <Typography v-if="Boolean(props.errors?.arNotes)" variant="form-error">
          {{ props.errors.arNotes }}
        </Typography>
      </InputGroup>
    </template>
  </DetailEditorBase>
</template>
